<template>
    <div class="flex flex-column">
        <label v-if="label" class="mb-2" :class="{ 'font-bold': props.bold }" :for="label">{{ label }}:</label>
        <InputText :class="{ 'p-invalid': props.errorMessage }" :type="props.type" :placeholder="props.placeholder" v-model.trim="selectedValue" :autofocus="props.autofocus" @change="updateSelectedInputValue" />
        <small class="p-invalid" v-if="props.errorMessage"> {{ props.errorMessage }}</small>
    </div>
</template>
<script setup>
import { ref, defineProps, onMounted, computed, watch, defineEmits } from 'vue';
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: String,
    },
    label: {
        type: String,
    },
    placeholder: {
        type: String,
        default: '',
    },
    errorMessage: {
        type: String,
    },
    bold: {
        type: Boolean,
        default: false,
    },
    autofocus: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: 'text',
    },
});
// computed properties
const inputValue = computed(() => {
    return props.modelValue;
});

// state
const selectedValue = ref(null);

// watches for modelValue changes
watch(inputValue, () => {
    updateSelectedValue();
});

onMounted(() => {
    if (inputValue.value) {
        updateSelectedValue();
    }
});

const updateSelectedValue = () => {
    selectedValue.value = inputValue.value;
    emit('update:modelValue', selectedValue.value);
};

const updateSelectedInputValue = () => {
    emit('update:modelValue', selectedValue.value);
};
</script>
